<div
  (cdkDropListDropped)="drop($event)"
  cdkDropList
  cdkDropListOrientation="horizontal"
  class="header"
>
  <ng-container *ngFor="let cell of row">
    <iv-live-preset-header-cell
      *ngIf="cell.type !== 'checkbox'"
      [value]="cell"
      [symbolSort]="symbolSort"
      [attr.data-field]="cell.dataField"
      [class.ascending]="cell.sortDirection === 'asc'"
      [class.descending]="cell.sortDirection === 'desc'"
      [class.with-tip]="cell.description"
      [style.width.px]="cell.width"
      [ngClass]="{ sortable: cell.dataField === 'symbol' }"
      (onSymbolSortClick)="toggleSortBySymbol()"
      (onMainSortClicked)="setOffSortBySymbol()"
    >
    </iv-live-preset-header-cell>
  </ng-container>
</div>
